import React, { useState } from "react";

// Define the namePattern for letter validation
const namePattern = /^[\p{L}\p{N}'.-]+(?: [\p{L}\p{N}'.@-]+)* ?$/u;

function TodoItem({ todo, updateTodo, deleteTodo, serial, toggleCheckbox }) {
  const [editText, setEditText] = useState(todo.text);
  const [error, setError] = useState("");

  const handleSave = () => {
    if (editText.trim().length === 0) {
      setError("Cannot be empty!");
      return;
    }
	
	 if (editText.trim().length > 25) {
    setError("Exceeds 25 letters!");
    return;
  }

    if (!namePattern.test(editText)) {
      setError("Please use letters, numbers, and valid symbols ('.', '-', '@').");
      return;
    }

    setError("");
    updateTodo(todo.id, editText); // Save and exit edit mode
  };

  const handleChange = (e) => {
    let newText = e.target.value;
    newText = newText.replace(/\b\w/g, (char) => char.toUpperCase());
    setEditText(newText);

    if (newText.trim().length > 25) {
      setError("Exceeds 25 letters!");
    } else if (!namePattern.test(newText)) {
      setError("Please use letters, numbers, and valid symbols ('.', '-', '@').");
    } else {
      setError("");
    }
  };

  return (
   // Inside <li> ... keep styles as before
    <li
      style={{
        display: "grid",
        gridTemplateColumns: "40px 40px 1fr auto",
        alignItems: "center",
        gap: "10px",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
        marginBottom: "10px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {/* Checkbox - now comes first */}
      <div>
  <input
    type="checkbox"
    checked={todo.checked}
    onChange={() => toggleCheckbox(todo.id)}
    style={{ width: '25%', transform: "scale(1.2)" }}
  />
</div>


      {/* Serial Number */}
      <div
        style={{
          backgroundColor: "#ffcccb",
          borderRadius: "4px",
          padding: "4px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {serial}.
      </div>

     

      {/* Text or Edit Field */}
      <div style={{ width: "100%" }}>
        {todo.isEditing ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={editText}
              onChange={handleChange}
              style={{
                padding: "5px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                flex: "1",
              }}
            />
            <button
              onClick={handleSave}
              style={{
                marginLeft: "10px",
                padding: "5px 10px",
                backgroundColor: "#1dd1a1",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Save
            </button>
          </div>
        ) : (
          <div
            style={{
              padding: "5px",
              backgroundColor: "#d0f0c0",
              borderRadius: "4px",
              wordWrap: "break-word",
            }}
          >
            {todo.text}
          </div>
        )}
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", gap: "5px" }}>
        {!todo.isEditing && (
          <>
            <button
              onClick={() => updateTodo(todo.id, todo.text, true)}
              style={{
                padding: "5px 10px",
                backgroundColor: "#6c63ff",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Edit
            </button>
            <button
              onClick={() => deleteTodo(todo.id)}
              style={{
                padding: "5px 10px",
                backgroundColor: "#ff6b6b",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Delete
            </button>
          </>
        )}
      </div>

      {/* Error message */}
      {error && (
        <div
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "5px",
            gridColumn: "1 / span 4",
          }}
        >
          {error}
        </div>
      )}
    </li>
  );
}

export default TodoItem;
